import { createStore } from "vuex";
import axios from "axios";
const API_HOST = window.__apiHost;
const BLOCK_LIST = '/api/krainaabc/block/list?device=www';
const BLOCK_ITEM = '/api/krainaabc/block?device=www&id=';
const FOOTER_LINKS = '/api/krainaabc/partial/footer/links?device=www';
const FOOTER_LOGOS = '/api/krainaabc/partial/footer/logos?device=www';
const USER_PROFILE = `${API_HOST}/api/account/user/profile`;
const GLOBAL_USER = `${API_HOST}/api/account/user-application-data`;
const SUBPROFILES = '/api/krainaabc/subprofile/list?device=www';
const SEND_CONTACT = '/api/krainaabc/contact/send?device=www';
const FAVORITES = '/api/krainaabc/subprofile/favorite-list?device=www`';
const ACTIVE_SUBPROFILE = '/api/krainaabc/subprofile?device=www';
const LOGIN = 'https://user.tvp.pl/login.php?action=login&dump=json&src=krainaabc&device=krainaabc';
const LOGOUT = 'https://user.tvp.pl/login.php?action=logout&dump=json&src=krainaabc&device=krainaabc';
const META = `${API_HOST}/api/krainaabc/meta?id=`;

export default createStore({
    state: {
        pageSettings: window.__pageSettings,
        isSearch: false,
        isModalAccess: false,
        isDropmenu: false,
        isModalLogin: false,
        isModalBackdrop: false,
        pinLock: {},
        pinLockChild: {},
        isModalCreateProfil: false,
        isModalErrorOpen: false,
        isModalErrorLoading: false,
        isModalTimeLimit: false,
        isModalUnlock: false,
        sectionsData: [],
        footerLinks: [],
        footerLogos: [],
        playerData: [],
        newsData: [],
        loginData: [],
        userData: [],
        globalUserData: [],
        categoryColor: '',
        newProfileStep: 1,
        selectedAvatar: {},
        selectedProfile: '',
        subProfilesList: [],
        favoritesList: [],
        activeSubProfile: {},
        loggedIn: false,
        contactData: {},
        paths: {},
        history: [],
        isTimeIsUpRemind: false,
        isTimeIsUp: false,
        isOutOfHours: false,     
        gemiusIdentifier: 'bVA7AMNaeKo3ta2pblrpA5ZzHQGdPONEnM8Pa1U0k_L.s7', 
        activeTooltip: {}
    },
    getters: {
        isLoggedIn(state) {
            return state.loggedIn;
        },
        isSearch(state) {
            return state.isSearch;    
        },
        isModalBackdrop(state) {
            return state.isModalBackdrop;
        },
        isDropmenu(state) {
            return state.isDropmenu;
        },
        getModalLogin(state) {
            return state.isModalLogin;
        },
        getModalAccess(state) {
            return state.isModalAccess;
        },
        getModalCreateProfil(state) {
            return state.isModalCreateProfil;
        },
        getModalErrorOpen(state) {
            return state.isModalErrorOpen;
        },
        getModalErrorLoading(state) {
            return state.isModalErrorLoading;
        },
        getModalTimeLimit(state) {
            return state.isModalTimeLimit;
        },
        getModalUnlock(state) {
            return state.isModalUnlock;
        },
        getSectionsData(state) {
            return state.sectionsData;
        },
        getFooterLinks(state) {
            return state.footerLinks;
        },
        getFooterLogos(state) {
            return state.footerLogos;
        },
        getPlayerData(state) {
            return state.playerData;
        },
        getCategoryColor(state) {
            return state.categoryColor;
        },
        getLoginData(state) {
            return state.loginData;
        },
        getUserData(state) {
            return state.userData;
        },
        getGlobalUserData(state) {
            return state.globalUserData;
        },
        getNewProfileStep(state) {
            return state.newProfileStep;
        },
        getSelectedAvatar(state) {
            return state.selectedAvatar;
        },
        getSelectedProfile(state) {
            return state.selectedProfile;
        },
        getSubProfiles(state) {
            return state.subProfilesList;
        },
        getFavorites(state) {
            return state.favoritesList;
        },
        getContactData(state) {
            return state.contactData;
        },
        getActiveSubProfile(state) {
            return state.activeSubProfile;
        },
        getPinLock(state) {
            return state.pinLock;
        },
        getPinLockChild(state) {
            return state.pinLockChild;
        },
        getHistory(state) {
            return state.history;
        },
        isTimeRestriction(state) {
            return state.isTimeRestriction;
        },
        isTimeIsUpRemind(state) {
            return state.isTimeIsUpRemind;
        },
        isTimeIsUp(state) {
            return state.isTimeIsUp;
        },
        isOutOfHours(state) {
            return state.isOutOfHours;
        },
        getGemiusIdentifier(state) {
            return state.gemiusIdentifier;
        },
        getMetaData(state) {
            return state.metaData;
        },
        getActiveTooltip(state) {
            return state.activeTooltip;
        }
    },
    mutations: {
        changeIsLoggedIn(state) {
            state.loggedIn = !state.loggedIn;
        },
        changeSearchState(state) {
            state.isSearch = !state.isSearch;
        },
        changeDropmenuState(state) {
            state.isDropmenu = !state.isDropmenu;
        },
        changeModalBackdrop(state, payload) {
            state.isModalBackdrop = payload;
        },
        changeModalAccessState(state) {
            state.isModalAccess = !state.isModalAccess;
        },
        changeModalCreateProfilState(state) {
            state.isModalCreateProfil = !state.isModalCreateProfil;
        },
        changeModalErrorOpenState(state) {
            state.isModalErrorOpen = !state.isModalErrorOpen;
        },
        changeModalErrorLoadingState(state, payload) {
            state.isModalErrorLoading = payload;
        },
        changeModalTimeLimitState(state, payload) {
            state.isModalTimeLimit = payload;
        },
        changeModalUnlock(state, payload) {
            console.log(`changeModalUnlock ${payload}`);
            state.isModalUnlock = payload;
        },
        changeModalLoginState(state) {
            state.isModalLogin = !state.isModalLogin;
        },
        clearSectionData(state) {
            state.sectionsData = [];
        },
        addsectionsData(state, payload) {
            if (state.sectionsData && state.sectionsData.length) {
                state.sectionsData = [...state.sectionsData, payload];
            } else {
                state.sectionsData = [payload];
            }
        },
        setFooterLinks(state, payload) {
            state.footerLinks = payload;
        },
        setFooterLogos(state, payload) {
            state.footerLogos = payload;
        },
        changePlayerState(state, payload) {
            state.playerData = payload.data;
        },
        setCategoryColor(state, payload) {
            state.categoryColor = payload;
        },
        addNewsData(state, payload) {
            state.newsData = payload;
        },
        addLoginData(state, payload) {
            state.loginData = payload;
        },
        addUserData(state, payload) {
            state.userData = payload;
        },
        addGlobalUserData(state, payload) {
            state.globalUserData = payload;
        },
        changeNewProfileStep(state, payload) {
            state.newProfileStep = payload;
        },
        changeSelectedAvatar(state, payload) {
            state.selectedAvatar = payload;
        },
        changeSelectedProfile(state, payload) {
            state.selectedProfile = payload;
        },
        setSubProfiles(state, payload) {
            state.subProfilesList = payload;
        },
        setFavorites(state, payload) {
            state.favoritesList = payload;
        },
        addContactData(state, data) {
            state.contactData = data;
        },
        setActiveSubProfile(state, payload) {
            state.activeSubProfile = payload;
        },
        changePinLock(state, payload) {
            state.pinLock.isOpen = payload && payload.isOpen || false;
            state.pinLock.id = payload && payload.id || null;
            state.pinLock.path = payload && payload.path || null;
            state.pinLock.mode = payload && payload.mode || null; // 'unlock', 'remind', 'access'
        },
        changePinLockChild(state, payload) {
            if(payload.subProfile && payload.subProfile._id) {
                state.pinLockChild.subProfile = payload.subProfile;
            } else {
                state.pinLockChild.subProfile = null;
            }

            state.pinLockChild.mode = payload.mode; // 'unlock', 'remind', 'hide'
        },
        addToHistory(state, payload) {
            if(!state.history.some(el => el.path === payload.path)) {
                state.history.push(payload);
            }
        },
        setTimeRestriction(state, payload) {
            state.isTimeRestriction = payload;
        },
        setIsTimeIsUp(state, payload) {
            state.isTimeIsUp = payload;
        },
        setIsTimeIsUpRemind(state, payload) {
            state.isTimeIsUpRemind = payload;
        },
        setIsOutOfHours(state, payload) {
            state.isOutOfHours = payload;
        },
        addMetaData(state, data) {
            state.metaData = data;
        },
        setActiveTooltip(state, payload) {
            state.activeTooltip = payload;
        }
    },
    actions: {
        changeIsLoggedIn(context) {
            context.commit("changeIsLoggedIn");
        },
        changeSearchState(context) {
            context.commit("changeSearchState");
        },
        changeDropmenuState(context) {
            context.commit("changeDropmenuState");
        },
        changeModalBackdrop(context, payload) {
            context.commit("changeModalBackdrop", payload);
        },
        changeModalAccessState(context) {
            context.commit("changeModalAccessState");
        },
        changeModalCreateProfilState(context) {
            context.commit("changeModalCreateProfilState");
        },
        changeModalErrorOpenState(context) {
            context.commit("changeModalErrorOpenState");
        },
        changeModalErrorLoadingState(context, payload) {
            context.commit("changeModalErrorLoadingState", payload);
        },
        changeModalLoginState(context) {
            context.commit("changeModalLoginState");
        },
        changeModalUnlock(context, payload) {
            context.commit("changeModalUnlock", payload);
        },
        changePinLock(context, payload) {
            context.commit("changePinLock", payload);
        },
        changePinLockChild(context, payload) {
            context.commit("changePinLockChild", payload);
        },
        changeModalTimeLimitState(context, payload) {
            context.commit("changeModalTimeLimitState", payload);
        },
        changeElToUnlock(context, payload) {
            context.commit("changeElToUnlock", payload);
        },
        changeNewProfileStep(context, payload) {
            context.commit("changeNewProfileStep", payload);
        },
        clearSectionData(context) {
            context.commit("clearSectionData");
        },
        getHomeIds(context) {
            axios.get(BLOCK_LIST).then((response) => {
                const modules = response.data.data.items;
                async function getModulesFromApi() {
                    for (const item of modules) {
                        if (item._id !== undefined) {
                            await axios.get(`${BLOCK_ITEM}${item._id}`).then((elems) => {
                                if (
                                    elems.data &&
                                    elems.data.data &&
                                    elems.data.data.items.length > 0
                                ) {
                                    context.commit("addsectionsData", elems.data.data);
                                }
                            });
                        }
                    }
                }
                getModulesFromApi();
            });
        },
        getFooterLinks(context) {
            axios.get(FOOTER_LINKS).then((response) => {
                if (response.status == 200) {
                    context.commit("setFooterLinks", response.data.data);
                } else {
                    console.log("Brak danych");
                }
            });
        },
        getFooterLogos(context) {
            axios.get(FOOTER_LOGOS).then((response) => {
                if (response.status == 200) {
                    context.commit("setFooterLogos", response.data.data);
                } else {
                    console.log("Brak danych");
                }
            });
        },
        addFavoriteItem(context, payload) {
            context.commit("addFavoriteItem", payload);
        },
        removeFavoriteItem(context, payload) {
            context.commit("removeFavoriteItem", payload);
        },
        changePlayerState(context, payload) {
            context.commit("changePlayerState", payload);
        },
        setCategoryColor(context, payload) {
            context.commit("setCategoryColor", payload);
        },
        changeSelectedAvatar(context, payload) {
            context.commit("changeSelectedAvatar", payload);
        },
        changeSelectedProfile(context, payload) {
            context.commit("changeSelectedProfile", payload);
        },
        addToHistory(context, payload) {
            context.commit("addToHistory", payload);
        },        
        login(context, payload) {
            var data = new FormData();
            data.append("email", payload.email);
            data.append("password", payload.password);
            data.append("token", payload.token);
            axios.defaults.withCredentials = true;
            axios
                .post(LOGIN, data)
                .then((response) => {
                    // this.dispatch("subProfiles");
                    context.commit("addLoginData", response.data);
                })
                .catch((error) => {
                    console.log(`error ${error}`);
                    if(error && error.response) {
                        context.commit("addLoginData", error.response.data);
                    }
                });
        },
        logout(context) {
            axios.defaults.withCredentials = true;
            axios.get(LOGOUT).then((response) => {
                context.commit("addUserData", response.data);
                context.commit("setSubProfiles", []);
                context.commit("changeIsLoggedIn"); 
            });
        },
        userinfo(context) {
            const endpoint = `${USER_PROFILE}`;
            axios.defaults.headers = {
                "Cache-Control": "no-cache",
                Pragma: "no-cache",
                Expires: "0",
            };
            axios.defaults.withCredentials = true;
            axios
                .post(endpoint)
                .then((response) => {
                    if (response.status == 200 && response.data !== "null") {
                        context.commit("addUserData", response.data);
                    } else {
                        console.log("Brak danych");
                    }
                })
                .catch((error) => {
                    if(error && error.response) {
                        context.dispatch("logout");
                        console.log(
                            `Wystąpił błąd: ${error.response.status} (${error.response.statusText})`
                        );
                    }
                });
        },
        globalUserData(context) {
            const data = {};
            data['src'] = 'krainaabc';
            axios.defaults.withCredentials = true;
            axios
                .post(GLOBAL_USER, data)
                .then((response) => {
                    if (response.status == 200 && response.data !== "null") {
                        context.commit("addGlobalUserData", response.data.data);
                    } else {
                        console.log("Brak danych");
                    }
                })
                .catch((error) => {
                    if(error && error.response) {
                        console.log(
                            `Wystąpił błąd: ${error.response.status} (${error.response.statusText})`
                        );
                    }
                });
        },
        subProfiles(context) {
            axios.get(SUBPROFILES).then((response) => {
                if (response.status === 200) {
                    if(response.data && response.data.data) {
                        context.commit("setSubProfiles", response.data.data);
                    }
                }
            });            
        },
        favorites(context, payload) {
            if(payload && payload.id) {
                let data = {};
                let endpoint = FAVORITES;
                data['subProfile_id'] = payload.id;

                if(payload.itemsPerPage && payload.itemsPage) {
                    endpoint = endpoint + `?limit=${payload.itemsPerPage}&page=${payload.itemsPage}`;
                }
    
                axios.post(endpoint, data).then((response) => {
                    if (response.status === 200) {
                        if(response.data && response.data.data) {
                            context.commit("setFavorites", response.data.data);
                        }
                    }
                }); 
            } else {
                context.commit("setFavorites", null);
            }
        },
        sendContact(context, payload) {
            let data = new FormData();
            
            data.append("email", payload.email);
            data.append("subject", payload.subject);
            data.append("message", payload.message);
            data.append("agreement", payload.agreement);
            data.append("regulations", payload.regulations);

            axios.defaults.headers = {
                "Content-Type": "application/x-www-form-urlencoded",
            };

            axios
                .post(SEND_CONTACT, data)
                .then((response) => {
                    context.commit("addContactData", response.data);
                })
                .catch((error) => {
                    context.commit("addContactData", error.response.data.data);
                });
        },
        activeSubProfile(context) {
            axios
                .get(ACTIVE_SUBPROFILE)
                .then((response) => { 
                    if(response.data && response.data.data) {
                        context.commit("setActiveSubProfile", response.data.data);
                    } else {
                        context.commit("setActiveSubProfile", null);
                    }
                })
                .catch(() => {
                    // console.log(error);
                    context.commit("setActiveSubProfile", null);
                });
        },
        setSubProfiles(context, payload) {
            context.commit("setSubProfiles", payload);
        },    
        setTimeRestriction(context, payload) {
            context.commit("setTimeRestriction", payload);
        },
        setIsTimeIsUp(context, payload) {
            context.commit("setIsTimeIsUp", payload);
        },
        setIsTimeIsUpRemind(context, payload) {
            context.commit("setIsTimeIsUpRemind", payload);
        },
        setIsOutOfHours(context, payload) {
            context.commit("setIsOutOfHours", payload);
        },
        getMeta(context, payload) {
            return axios
                .get(META+payload.id)
                .then((response) => {
                    if (response.status == 200 && response.data !== "null") {
                        context.commit("addMetaData",response.data);
                    } else {
                        console.log("Brak danych");
                    }
                })
                .catch((error) => {
                    if(error && error.response) {
                        console.log(
                            `Wystąpił błąd: ${error.response.status} (${error.response.statusText})`
                        );
                    }
                });
        },
        setActiveTooltip(context, payload) {
            context.commit("setActiveTooltip", payload);
        }
    }
});
